module.exports = __webpack_public_path__ + "img/plus-big.6b986e69.svg";